import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getCartItemCount } from "../../utils/cart";
import AuthModal from "./AuthModal";
import {
  BaseUrl,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
} from "../../Services/Urls";
import { makeApiRequest, callApi } from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import { decryptOtp } from "../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../Context/Context";

const Footer = () => {
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error("useApiContext must be used within a ApiContextProvider");
  }

  const { logindata, setlogindata, userData, setuserData } = context;

  const [isScrolled, setIsScrolled] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (LoggedInUserID == null && LoggedInUserName == null) {
      const storedLoginData = localStorage.getItem("loginData-UniversalDairy");
      const storedUserData = localStorage.getItem("UserData-UniversalDairy");

      if (storedLoginData && storedUserData) {
        setIsLoggedIn(true);
        const parsedData = JSON.parse(storedLoginData);
        const parsedUserData = JSON.parse(storedUserData);

        setlogindata(parsedData);
        setLogindata(parsedData);

        setUserdata(parsedUserData);
        setuserData(parsedUserData);
      }
    }
  }, []);
  const handleLogout = () => {
    setlogindata({});
    setuserData({});

    setLogindata();
    setUserdata();

    localStorage.removeItem("loginData-UniversalDairy");
    localStorage.removeItem("UserData-UniversalDairy");
    setIsLoggedIn(false);
    setIsUserDropdownOpen(false);
    navigate("/");
  };

  const handleLoginSuccess = () => {
    setShowAuthModal(false);
    setIsLoggedIn(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <>
      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onLoginSuccess={handleLoginSuccess}
      />
      <footer className="bg-[#1A2B4A] text-white">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            <div>
              <h3 className="text-2xl font-bold mb-4">UNIVERSAL DPU</h3>
              <p className="text-white/80 mb-6 leading-relaxed">
                Intelligent solutions for modern dairy and agriculture industry,
                powered by Dial ERP. Transforming operations with cutting-edge
                technology.
              </p>
              <div className="flex gap-4">
                <a
                  href="https://www.linkedin.com/company/dialerp/"
                  className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-white transition-colors cursor-pointer"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>

                <a
                  href="https://wa.me/919560444000"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-white transition-colors cursor-pointer"
                  aria-label="Whatsapp"
                >
                  <i className="ri-whatsapp-line text-sm"></i>
                </a>
                <a
                  href="https://www.instagram.com/dial.erp"
                  className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-white transition-colors cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold mb-4 tracking-wider">
                CONTACT
              </h4>
              <div className="space-y-4 text-white/80">
                <div>
                  <p className="text-xs font-semibold mb-1">COMPANY</p>
                  <p className="text-sm"> DialERP Technologies Limited</p>
                </div>
                <div>
                  <p className="text-xs font-semibold mb-1">ADDRESS</p>
                  <p className="text-sm">6th Floor, 608, Padma Tower-2</p>
                  <p className="text-sm">Rajendra Place, Central Delhi</p>
                  <p className="text-sm">Delhi – 110008, India</p>
                </div>
                <div>
                  <p className="text-xs font-semibold mb-1">PHONE / WHATSAPP</p>
                  <div className="flex items-center gap-3">
                    <a
                      href="tel:+919560444000"
                      className="text-sm hover:text-white transition-colors cursor-pointer"
                    >
                      +91 9560444000
                    </a>
                    <a
                      href="https://wa.me/919560444000"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 bg-[#25D366] text-white px-2 py-1 rounded text-xs hover:bg-[#128C7E] transition-colors cursor-pointer"
                    >
                      <i className="ri-whatsapp-line"></i>
                      Chat
                    </a>
                  </div>
                </div>
                <div>
                  <p className="text-xs font-semibold mb-1">EMAIL</p>
                  <p className="text-sm">info@dialerp.com</p>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold mb-4 tracking-wider">
                QUICK LINKS
              </h4>
              <div className="space-y-2">
                <Link
                  to="/"
                  className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Home
                </Link>
                <Link
                  to="/software"
                  className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Software
                </Link>
                <Link
                  to="/products"
                  className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Products
                </Link>
                <Link
                  to="/about"
                  className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  About Us
                </Link>
                <Link
                  to="/contact"
                  className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Contact
                </Link>
                {LoggedInUserID == null && (
                  <div
                    onClick={() => {
                      if (LoggedInUserID != null) {
                        handleLogout();
                      } else {
                        setShowAuthModal(true);
                      }
                    }}
                    className="block text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                  >
                    {LoggedInUserID != null ? "Logout" : "Login"}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/60">
              © 2026 Universal DPU. All rights reserved.
            </p>

            <div className="px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap text-white/60">
              Powered by{" "}
              <a
                href="https://dialerp.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="https://dialerp.com/assets/images/DialERP-Footer-Logo.svg" />
              </a>
            </div>
            <div className="flex gap-6 text-sm text-white/60">
              <Link
                to="/privacy-policy"
                className="hover:text-white transition-colors cursor-pointer"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="hover:text-white transition-colors cursor-pointer"
              >
                Terms of Service
              </Link>
              {/* <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">
              Powered by Readdy
            </a> */}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
